import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
export { default as extend } from './extend';
app.initializers.add('ramon-mail-reply', () => {
  extend(CommentPost.prototype, 'headerItems', function (items) {
    if (!app.forum.attribute('mailReply.showBadge')) return;
    if (!this.attrs.post.viaMailReply()) return;
    const label = app.translator.trans('ramon-mail-reply.forum.via_mail', {}, true);
    items.add('mailReplyBadge', m("span", {
      className: "MailReplyBadge",
      title: label,
      "aria-label": label
    }, m("i", {
      className: "icon fas fa-envelope",
      "aria-hidden": "true"
    }), m("span", {
      className: "MailReplyBadge-text"
    }, label)), 95);
  });
});